var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { VariableDefinition } from '@flexem/fc-gui';
import { DiagramConsts } from '../diagram-consts';
import { ConditionalEnableNodeElement } from './base/conditional-enable-node-element';
import { DataTypeService } from '../../../../shared/fbox/fbox/dataType.service';
import { GraphService } from '../../../../shared/gallery/graph.service';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
var NumericalDisplayElement = /** @class */ (function (_super) {
    __extends(NumericalDisplayElement, _super);
    function NumericalDisplayElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.dataTypeService = injector.get(DataTypeService);
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    NumericalDisplayElement.prototype.compile = function (model, data, svg) {
        model['version'] = 5;
        model['angle'] = data.angle;
        if (data.variableVersion) {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === data.variableName; });
            if (null != variable) {
                model['dataType'] = variable.dataType;
                model['writeVariable'] = model['readVariable'] = { name: variable.variableName, variableVersion: data.variableVersion };
            }
        }
        else {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === data.dataSourceCode &&
                v.fBoxVariableName === data.variableName && (!data.variableGroupName || (v.fBoxGroupName === data.variableGroupName)); });
            if (null != variable) {
                model['dataType'] = variable.dataType;
                model['writeVariable'] = model['readVariable'] = new VariableDefinition(variable.fBoxVariableName, variable.fBoxGroupName, variable.dataSourceCode);
            }
        }
        model['integerDigits'] = data.integerDigits;
        model['fractionDigits'] = data.fractionDigits;
        model['accessPermission'] = data.accessPermission;
        model['useSecurity'] = data.useSecurity;
        model['isRecordOperation'] = data.isRecordOperation;
        if (data.isRecordOperation) {
            model['operationDescription'] = data.operationDescription;
        }
        model['enablePassword'] = data.enablePassword;
        model['useGraph'] = data.useGraph;
        model['graphSetting'] = data.graphSetting;
        model['size'] = this.sizeService.parse(data.size);
        model['font'] = data.font;
        model['fontSize'] = data.fontSize;
        model['isUnderline'] = data.isUnderline;
        model['stroke'] = data.stroke;
        model['textAlign'] = data.textAlign;
        model['numericalUpperLimit'] = data.numericalUpperLimit;
        model['numericalLowerLimit'] = data.numericalLowerLimit;
        model['enableNumericalOperation'] = data.enableNumericalOperation;
        if (model['enableNumericalOperation']) {
            model['numericalOperationSetting'] = data.numericalOperationSetting;
        }
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
        model['showUnit'] = data.showUnit;
        model['unit'] = data.unit;
        model['showVariableText'] = data.showVariableText;
        model['variableText'] = data.variableText;
        model['displayDataType'] = data.displayDataType ? data.displayDataType : 0;
        svg.children().remove();
    };
    NumericalDisplayElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/numerical-display.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    NumericalDisplayElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Auto', {
            rotatable: true,
            locationObjectName: 'SHAPE', locationSpot: go.Spot.TopLeft, resizable: true,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, { fill: 'transparent', stroke: 'gray', strokeWidth: 0.5, strokeDashArray: [4, 4] }, new go.Binding('visible', 'useGraph', function (useGraph) { return !useGraph; })), $(go.Panel, 'Horizontal', $(go.Panel, 'Auto', $(go.TextBlock, {
            alignment: go.Spot.Center,
            editable: false,
            verticalAlignment: go.Spot.Center,
        }, new go.Binding('margin', '', function (data) {
            var margin = 0;
            if (data.showVariableText) {
                margin = 8;
            }
            return margin;
        }), new go.Binding('desiredSize', '', function (data) { return _this.calcVariableTextSize(data); }), new go.Binding('visible', 'showVariableText'), new go.Binding('text', 'variableText', function (label) { return label.content + ':'; }), new go.Binding('font', 'variableText', function (label) {
            return _this.setEditTextFontFamilyMustBeYaHei(FontStyleHelper.buildFontStyle(label.font.isBold, label.font.isItalic, FontStyleHelper.addPx(label.font.fontSize)));
        }), new go.Binding('isUnderline', 'variableText', function (label) { return label.font.isUnderline; }), new go.Binding('stroke', 'variableText', function (label) { return label.font.color; }), new go.Binding('textAlign', 'variableText', function (label) { return label.font.textAlign; }))), $(go.Panel, 'Spot', $(go.Picture, { name: 'IMAGE' }, { sourceCrossOrigin: function (__) { return 'anonymous'; } }, new go.Binding('desiredSize', '', function (data) { return _this.calcGraphSize(data); }), new go.Binding('source', 'graphSetting', function (setting, __) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('visible', 'useGraph')), $(go.TextBlock, {
            alignment: go.Spot.Center,
            minSize: new go.Size(40, 10),
            editable: false,
            verticalAlignment: go.Spot.Center
        }, new go.Binding('desiredSize', '', function (data) { return _this.calcGraphSize(data); }), new go.Binding('textAlign').makeTwoWay(), new go.Binding('font', 'font', function (data) { return _this.setEditTextFontFamilyMustBeYaHei(data); }), new go.Binding('isUnderline').makeTwoWay(), new go.Binding('stroke').makeTwoWay(), new go.Binding('text', '', function (data) { return _this.getDefaultNumericalDisplayText(data); })))));
    };
    NumericalDisplayElement.prototype.setEditTextFontFamilyMustBeYaHei = function (font) {
        var fontArray = font.split('px');
        fontArray.pop();
        fontArray.push(' Microsoft YaHei,msyh');
        return fontArray.join('px');
    };
    NumericalDisplayElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.numericalDisplayKey;
    };
    NumericalDisplayElement.prototype.calcVariableTextSize = function (data) {
        var size;
        if (!data.size) {
            size = go.Size.parse('80 32');
        }
        else {
            size = go.Size.parse(data.size);
        }
        if (data.showVariableText) {
            size.width = size.width * 7 / 11 - 16;
        }
        else {
            size.width = 0;
        }
        if (size.width < 0) {
            size.width = 0;
        }
        if (size.height < 0) {
            size.height = 0;
        }
        return size;
    };
    NumericalDisplayElement.prototype.calcGraphSize = function (data) {
        var size;
        if (!data.size) {
            size = go.Size.parse('80 32');
        }
        else {
            size = go.Size.parse(data.size);
        }
        if (data.showVariableText) {
            size.width = size.width * 4 / 11;
        }
        if (size.width < 0) {
            size.width = 0;
        }
        if (size.height < 0) {
            size.height = 0;
        }
        return size;
    };
    NumericalDisplayElement.prototype.getDefaultNumericalDisplayText = function (nodeData) {
        var result = '';
        if (nodeData.variableName && nodeData.dataType && nodeData.variableName.length > 0) {
            if (this.dataTypeService.isHexType(nodeData.displayDataType)) {
                result = this.buildDefaultHexText(nodeData.integerDigits);
            }
            else if (this.dataTypeService.isBinaryType(nodeData.displayDataType)) {
                result = this.buildDefaultBinaryText(nodeData.integerDigits);
            }
            else {
                result = this.buildDefaultNumericalText(nodeData.integerDigits, nodeData.fractionDigits);
            }
        }
        if (nodeData.showUnit !== false && !_.isNil(nodeData.unit) && result !== '') {
            result = result + " " + nodeData.unit;
        }
        return result;
    };
    NumericalDisplayElement.prototype.buildDefaultBinaryText = function (integerDigits) {
        return '1'.repeat(integerDigits);
    };
    NumericalDisplayElement.prototype.buildDefaultHexText = function (integerDigits) {
        return 'F'.repeat(integerDigits);
    };
    NumericalDisplayElement.prototype.buildDefaultNumericalText = function (integerDigits, fractionDigits) {
        var displayText = '';
        var index = 1;
        if (integerDigits > 0) {
            var displayIntegerText = '';
            for (; index <= integerDigits; index++) {
                displayIntegerText += index % 10;
            }
            displayText += displayIntegerText;
        }
        if (fractionDigits > 0) {
            var displayDecimalText = '';
            for (; index <= integerDigits + fractionDigits; index++) {
                displayDecimalText += index % 10;
            }
            displayText += (integerDigits > 0 ? '.' : '0.') + displayDecimalText;
        }
        return displayText;
    };
    return NumericalDisplayElement;
}(ConditionalEnableNodeElement));
export { NumericalDisplayElement };
